import logger from './logger';

export const fetchListings = async (bounds) => {
  try {
    // Relative to the host serving the app, so it works on any hostname/port
    const url = new URL('/api/listings', window.location.origin);
    
    // Add bounds parameters if provided
    if (bounds) {
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      url.searchParams.append('ne_lat', ne.lat);
      url.searchParams.append('ne_lng', ne.lng);
      url.searchParams.append('sw_lat', sw.lat);
      url.searchParams.append('sw_lng', sw.lng);
      console.debug(`Bounds: NE lat:${ne.lat.toString()}, NE long:${ne.lng.toString()}, SW Lat: ${sw.lat.toString()}, SW Long: ${sw.lng.toString()}`);
    }    
    console.debug(`[API] Fetching listings from ${url.toString()}`);
    logger.log(`[API] Fetching listings from ${url.toString()}`);

    const response = await fetch(url.toString(), {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    
    console.debug(`[API] Response status: ${response.status}`);
    logger.log(`[API] Response status: ${response.status}`);
    
    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`);
      console.error('[API] Request failed:', error);
      logger.log('[API] Request failed:', error);
      throw error;
    }
    
    const data = await response.json();
    console.debug('[API] Received listings:', {
      count: data.length,
      firstItem: data[0] ? {id: data[0].id, title: data[0].title} : null
    });
    logger.log('[API] Received listings:', {
      count: data.length,
      firstItem: data[0] ? {id: data[0].id, title: data[0].title} : null
    });
    
    return data;
  } catch (error) {
    console.error('[API] Failed to fetch listings:', {
      error: error.message,
      stack: error.stack
    });
    throw error;
  }
};